import NegativePromptInput from './NegativePromptInput'

export default NegativePromptInput
